import script from "./KnowledgeBasesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./KnowledgeBasesList.vue?vue&type=script&lang=ts&setup=true"

import "./KnowledgeBasesList.vue?vue&type=style&index=0&id=c23c9fc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c23c9fc0"]])

export default __exports__